import Vue from 'vue';
const cacheMap = {};

function createInstance(component, options = {}, name = '') {
  if (cacheMap[name]) {
    return cacheMap[name];
  }
  const vueObj = new Vue({
    render(h) {
      return h(component, { props: this.$data });
    },
    data() {
      return {
        data: options,
      };
    },
  });

  vueObj.$mount(document.createElement('div'));
  document.body.appendChild(vueObj.$el);
  if (name) {
    const [child] = vueObj.$children; // 第1个元素
    cacheMap[name] = child;
  }
  return vueObj.$children[0];
}

export default createInstance;
